import { Injectable } from '@angular/core';
import {UtilService} from "../util/util.service";
import {ConversationSessionType} from "./conversation-session-type";
import {ConversationSessionContext} from "./conversation-session-context";
import {ConversationSessionOptions} from "./conversation-session-options";
import {ConversationRequestContext} from "./conversation-request-context";
import {LegacyInitializer} from "../initialization/legacy.initializer";
import {ConversationResponseChatCompletionChunk} from "./conversation-response-chat-completion-chunk";

@Injectable({
  providedIn: 'root'
})
export class OpenAIService {

  private sessions: {
    [key: string]: ConversationSessionOptions;
  } = {};

  constructor(private utilService: UtilService,
              private legacyInitializer: LegacyInitializer) {

    this.legacyInitializer.legacyLoaded.subscribe((e) => {

      (window as any).WebsocketAPI.registerAPIImplementation("OpenAI", (data: any, responseBody: any) => {
        const topic = responseBody.topic;
        const [topicKind, clientSessionId] = topic.split('.');

        if (topicKind == "reply") {
          const session = this.sessions[clientSessionId];

          if (session) {
            const response = JSON.parse(data);
            const chunk: ConversationResponseChatCompletionChunk = response.chunk;
            const combinedChunks = response.combinedChunks;
            const type = response.type;
            session.callback(chunk, combinedChunks, type);
          }
        }
      });

    });
  }

  async createChatSession(options: ConversationSessionOptions, context: ConversationRequestContext) {

    const override = {
      clientSessionId: options.clientSessionId || this.utilService.generateUUID(),
      sessionType: options.sessionType || ConversationSessionType.ANALYSE_RECORD,
      count: options.count || 1
    };

    options = this.buildOptions(options, override);

    const body = this.buildBody(options, context);

    const response = await this.sendRequest("/_openai/chat/create", body);

    this.registerSession(options);

    return response;
  }

  async sendChatSession(options: ConversationSessionOptions, context: ConversationRequestContext) {

    const body = this.buildBody(this.buildOptions(options), context);

    const response = await this.sendRequest("/_openai/chat/send", body);

    return response;
  }

  async terminateChatSession(options: ConversationSessionOptions) {

    const body = this.buildBody(this.buildOptions(options));

    await this.sendRequest("/_openai/chat/terminate", body);

    this.deregisterSession(options);
  }

  private buildOptions(options: ConversationSessionOptions, override?: ConversationSessionOptions) {
    return Object.assign(options, override || {});
  }

  private buildBody(options: ConversationSessionOptions, context?: ConversationRequestContext): ConversationSessionContext {
    return {
      clientSessionId: options.clientSessionId,
      sessionType: options.sessionType,
      options: options,
      context: context
    };
  }

  private async sendRequest(url: string, body?: object) {
    let result = await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }
    );

    return await result.json();
  }

  private registerSession(options: ConversationSessionOptions) {
    this.sessions[options.clientSessionId] = options;
  }

  private deregisterSession(options: ConversationSessionOptions) {
    delete this.sessions[options.clientSessionId];
  }
}

